var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEvolbsIcon7(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_3_24",
    "data-name": "Component 3 \\u2013 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.734,
    height: 23.451,
    viewBox: "0 0 26.734 23.451",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M24.635,247.186a.764.764,0,0,0,1.081,0,4.911,4.911,0,0,0,0-6.945.764.764,0,0,0-1.081,1.08,3.387,3.387,0,0,1,0,4.785.764.764,0,0,0,0,1.081",
    transform: "translate(-3.462 -236.353)",
    fill: "#4e428d"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M12.83,258.975a.764.764,0,0,0,1.081,0L24.586,248.3a7.353,7.353,0,0,0-10.4-10.4l-.816.817-.817-.817a7.353,7.353,0,0,0-10.4,10.4ZM3.236,238.982a5.825,5.825,0,0,1,8.238,0l1.356,1.357a.765.765,0,0,0,1.081,0l1.357-1.357a5.825,5.825,0,0,1,8.238,8.238L13.371,257.355,3.236,247.22a5.825,5.825,0,0,1,0-8.238",
    transform: "translate(-0.002 -235.748)",
    fill: "#4e428d"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEvolbsIcon7);
export default __webpack_public_path__ + "static/media/evolbs_icon7.dc573d0b.svg";
export { ForwardRef as ReactComponent };